import 'owl.carousel2';

window.HomeBundle = function () {
	$('.js-jumbotron-slider').owlCarousel({
		loop: true,
		nav: false,
		dots: true,
		items: 1,
		autoplay: true,
		autoplayTimeout: 18000,
		autoplaySpeed: 800,
		autoplayHoverPause: true,
		onInitialized: event => {
			$('.owl-dot').each(function () {
				$(this).html('<span class="jumbotron-slider__page-nb">0' + ($(this).index() + 1) + '</span>');
			});
		}
	});

	$('.js-partners-carousel').owlCarousel({
		loop: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 3
			},
			992: {
				items: 4
			},
			// 1440: {
			// 	items: 6
			// },
		},
		navText: ['<i class="far fa-chevron-left"></i>', '<i class="far fa-chevron-right"></i>']
	});
};

